import { atom } from "jotai";
export var editorViewAtom = atom(null);